import script from "./PUR01_032INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR01_032INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR01_032INS.vue?vue&type=style&index=0&id=10fc070d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10fc070d"]])

export default __exports__